import router from '@/router';
import sensors from 'sa-sdk-javascript';
import Vue from 'vue';
import { getLaunchParams } from '@/utils/launchParams';

const PLATFORM = process.env.VUE_APP_PLATFORM;

sensors.init({
  server_url: 'https://api.xintaicz.cn/sa?project=TTminiProgram',
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  show_log: process.env.NODE_ENV === "development",  // 测试环境: 浏览器开发者工具会打印采集的事件信息
  send_type: 'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'not_collect',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect'
  }
});

const getUid = () => {
  try {
    const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    return userInfo?.id || '';
  } catch (error) {
    return '';
  }
};

const getUUID = () => {
  if (localStorage.getItem("UUID")) {
    return localStorage.getItem("UUID");
  } else {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    localStorage.setItem("UUID", uuid);
    return uuid;
  }
};


// 设置神策公参
try {
  sensors.registerPage({
    platform: `WEB_TT_${PLATFORM}`,
    uuid: getUUID(),
    module: () => {
      return router?.currentRoute?.name || "";
    },
    utm_campaign: () => getLaunchParams().utm_campaign || '',
    utm_content: () => getLaunchParams().utm_content || '',
    adset_id: () => getLaunchParams().adset_id || '',
    ad_ids: () => getLaunchParams().ad_ids || '',
    ad_id: () => getLaunchParams().ad_id || '',
    placement: () => getLaunchParams().placement || '',
    plan: () => getLaunchParams().plan || '',
    subscription: () => getLaunchParams().subscription || '',
    purchase: () => getLaunchParams().purchase || '',
    coin_count: () => getLaunchParams().coin_count || '',
    priority: () => getLaunchParams().priority || '',
  });
  setTimeout(() => sensors.quick('autoTrack'), 100);
} catch (error) {
  console.log(error);
}

export const logSensor = (data) => {
  if (!data.event) return;
  const eventName = data.event;
  delete data.event;
  sensors.track("webtt_" + eventName, data);
};

Vue.prototype.$logSensor = logSensor;

var logUrl = 'https://log.goodreels.com/pclogpd.php'; // 点击、pv、event打点url

class Log {
  constructor(data = {}) {
    const isIos = !!window.navigator.userAgent.match(/.+Mac OS X/);
    this.data = {
      userAgent: window.navigator.userAgent, // 当前浏览器的用户代理字符串
      sw: window.screen?.width, // 获取屏幕分辨率的宽度
      sh: window.screen?.height, // 获取屏幕分辨率的高度
      deviceId: "", // 唯一标识符
      ...data,
      platform: `GR_TT_${PLATFORM}`,
      map: {
        module: router.currentRoute?.name || '',
        uuid: getUUID(),
        uid: getUid(),
        platform: isIos ? "IOS" : "AND",
        lang: localStorage.getItem("lang") || "en",
        ...(data.map || {}),
        utm_campaign: getLaunchParams().utm_campaign || '',
        utm_content: getLaunchParams().utm_content || '',
        adset_id: getLaunchParams().adset_id || '',
        ad_ids: getLaunchParams().ad_ids || '',
        ad_id: getLaunchParams().ad_id || '',
        placement: getLaunchParams().placement || '',
        plan: getLaunchParams().plan || '',
        subscription: getLaunchParams().subscription || '',
        purchase: getLaunchParams().purchase || '',
        coin_count: getLaunchParams().coin_count || '',
        priority: getLaunchParams().priority || '',
      }
    };

    this.sendLog();
  }

  sendLog() {
    try {
      const url = logUrl + '?json=' + JSON.stringify(this.data);
      if (window.navigator.sendBeacon) {
        window.navigator.sendBeacon(url);
      } else {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.send();
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export const logPv = function (data) {
  new Log({
    tag: 101,
    ...data,
    prev: data.prev || '', // 上一个页面非必填
    ptype: data.ptype || '', // 当前页面必填
  });
};

export const logClick = function (data) {
  new Log({
    tag: 102,
    ...data,
    module: data.module || router.currentRoute?.name || '', // 当前点击元素的所属页面
    zone: data.zone || '', // 点击的区域
    adid: data.adid || '', // 点击元素的id(例如书籍id之类)
  });
};

export const logEvent = function (data) {
  new Log({
    tag: 103,
    ...data,
    event: `webtt_${data.event || ''}`, // 事件名称：例如，czcg,fbcg
  });
};

Vue.prototype.$logPv = logPv;
Vue.prototype.$logClick = logClick;
Vue.prototype.$logEvent = logEvent;



window.onerror = function (msg, source, line, column, error) {
  Vue.prototype.$logEvent({
    event: 'webtt_page_javascript_error',
    map: {
      msg,
      source: source ? source.split('?')[0] : '',
      line,
      column,
      error: error?.stack
    }
  });
};

